export default "__VITE_ASSET__9d4a86d9__"